import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import MonitoringPortalsListModal from 'components/molecules/monitoring_portals_list_modal';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import MonitoringPortals from 'services/monitoring_portals';
import { MonitoringRequestTypes, MonitoringState } from 'store/modules/monitoring_store/types';
import { PanelState } from 'store/modules/panel_store/types';

type Option = {
  value: number;
  label: string;
};

const TradingPortalFilters = () => {
  const ALL_PORTALS_ID = 0;

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);
  const { monitoring } = useSelector<ApplicationState, MonitoringState>(
    (state) => state.storage.monitoring,
  );
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);

  const [modalListOpened, setModalListOpened] = useState<boolean>(false);
  const [portalsSelected, setPortalsSelected] = useState<Option[]>([]);

  const sourceIdsList = monitoring.monitored_source_id_list
    ? [ALL_PORTALS_ID, ...monitoring.monitored_source_id_list]
    : [ALL_PORTALS_ID];

  const portals = MonitoringPortals(profile.beta_tester);
  const filteredPortals = portals.filter((portal) => sourceIdsList.includes(portal.value));

  const dispatch = useDispatch();

  if (panel.partner_id > 0)
    return (
      <div>
        <button
          type="button"
          className="btn btn-link btn-sm ml-md-1 text-nowrap d-flex align-items-center"
          data-toggle="modal"
          data-target="#monitoring-portals-modal"
          onClick={() => setModalListOpened(true)}
        >
          <i className="material-icons mr-1">campaign</i>
          Conheça todos os portais disponíveis na plataforma ConLicitação
        </button>
        <MonitoringPortalsListModal
          modalListOpened={modalListOpened}
          setModalListOpened={setModalListOpened}
        />
      </div>
    );

  return (
    <div className="px-3">
      <div className="d-md-flex d-block">
        <div className="w-100 trading-portal-filters">
          <Select
            isMulti
            closeMenuOnSelect={false}
            name="users"
            options={filteredPortals}
            placeholder="Todos os pregões monitorados"
            value={portalsSelected}
            classNamePrefix="select"
            className="basic-multi-select"
            onChange={(selected) => {
              setPortalsSelected(selected as Option[]);
              dispatch({
                type: MonitoringRequestTypes.UPDATE_CURRENT_SOURCE_ID,
                sourceId: (selected as Option[]).map((opt) => opt.value),
              });
            }}
          />
        </div>
      </div>
      <MonitoringPortalsListModal
        modalListOpened={modalListOpened}
        setModalListOpened={setModalListOpened}
      />
    </div>
  );
};

export default TradingPortalFilters;
